import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  PaymentActionError,
  PaymentActionResult,
  PaymentFormField,
} from '@cashier/cashier-model';

export interface ConfirmationDataItem {
  name: string;
  value: string | null;
  isValid: boolean;
}

export interface PaymentConfirmationState {
  fieldConfigurations: PaymentFormField[];
}

export const PAYMENT_CONFIRMATION_FEATURE_KEY = 'paymentConfirmation';

export const paymentConfirmationSlice = createSlice({
  name: PAYMENT_CONFIRMATION_FEATURE_KEY,
  initialState: null,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    initiateConfirmation: (_) => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    confirmationTimeout: (_) => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    confirmPaymentStart: (_, __: PayloadAction<any>) => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    confirmPaymentSuccess: (_, __: PayloadAction<PaymentActionResult>) => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    confirmPaymentFailure: (_, __: PayloadAction<PaymentActionError>) => {},
  },
});

export const paymentConfirmationReducer = paymentConfirmationSlice.reducer;

export const {
  initiateConfirmation,
  confirmationTimeout,
  confirmPaymentStart,
  confirmPaymentSuccess,
  confirmPaymentFailure,
} = paymentConfirmationSlice.actions;
